export default __webpack_public_path__ + "static/gg-medium-f30fa600f4500fde75b036abaf500a1e.woff2";